import type { FormikHelpers } from 'formik';
import * as apiObject from 'api/apiObjects';
import { toSavePayload } from './mergeTeamWorkers';
import type { WorkersFormValues } from './types';

type TranslateFn = (key: string) => string;
type ShowToastFn = (message: string, type?: string) => void;

export interface SubmitWorkersParams {
    objectId: number;
    expendId: number;
    incomeAmount: number;
    t: TranslateFn;
    showToast: ShowToastFn;
    onSuccess: () => Promise<void> | void;
}

const AMOUNT_EPS = 0.01;

export const submitWorkers = async (
    values: WorkersFormValues,
    helpers: FormikHelpers<WorkersFormValues>,
    params: SubmitWorkersParams,
): Promise<void> => {
    const { objectId, expendId, incomeAmount, t, showToast, onSuccess } = params;
    const { setSubmitting } = helpers;

    const allocated = (values.rows || []).reduce((sum, row) => sum + (Number(row.amount) || 0), 0);
    if (allocated - incomeAmount > AMOUNT_EPS) {
        showToast(t('expendTeamWorkers.errOverLimit'), 'danger');
        setSubmitting(false);
        return;
    }

    setSubmitting(true);
    try {
        const res = await apiObject.saveExpendTeamWorkers(objectId, expendId, {
            workers: toSavePayload(values.rows || []),
        });

        if (res?.stat) {
            await onSuccess();
            showToast(t('expendTeamWorkers.messSaved'), 'success');
            return;
        }

        if (res?.errCode === 'OVER_LIMIT') {
            showToast(t('expendTeamWorkers.errOverLimit'), 'danger');
            return;
        }
        if (res?.errCode === 'INVALID_ROLE') {
            showToast(t('expendTeamWorkers.errRole'), 'danger');
            return;
        }
        if (res?.errCode === 'CANCELLED') {
            showToast(t('expendTeamWorkers.errCancelled'), 'danger');
            return;
        }
        if (res?.errCode === 'OBJECT_LOCKED') {
            showToast(t('expendTeamWorkers.errLocked'), 'danger');
            return;
        }

        showToast(t('common:messError'), 'danger');
    } finally {
        setSubmitting(false);
    }
};
